window.dataLayer = window.dataLayer || [];
window.intlTelInput = require('intl-tel-input');

// intl-tel-input initialization
const phoneInput = document.querySelector("#phone");
const countryCodeInput = document.querySelector("#country_code");
const countryNameInput = document.querySelector("#country_name");

if (phoneInput) {
    const iti = window.intlTelInput(phoneInput, {
        separateDialCode: true,
        initialCountry: "auto",
        // preferredCountries: ["my"],
        hiddenInput: "phone_number",
        utilsScript: require("intl-tel-input/build/js/utils.js"),
        geoIpLookup: (success, failure) => {
            fetch("https://ipapi.co/json").then((res) => res.json()).then((data) => success(data.country_code)).catch(() => failure());
        },
    });

    // Set initial country's ISO code when the page loads
    const initialCountryData = iti.getSelectedCountryData();
    countryCodeInput.value = initialCountryData.iso2;
    countryNameInput.value = initialCountryData.name;

    // Listen for country change
    phoneInput.addEventListener('countrychange', function (e) {
        const selectedCountryData = iti.getSelectedCountryData();
        countryCodeInput.value = selectedCountryData.iso2;
        countryNameInput.value = selectedCountryData.name;
    });

    // Restrict input to numeric characters only
    function restrictNonNumeric(event) {
        const inputElement = event.target;
        const currentValue = inputElement.value;
        const onlyNumericValue = currentValue.replace(/[^0-9]/g, '');

        if (currentValue !== onlyNumericValue) {
            inputElement.value = onlyNumericValue;
        }
    }

    // Attach input event handler to restrict non-numeric input
    phoneInput.addEventListener('input', restrictNonNumeric);

    // Adjust dropdown width to match input field
    const adjustDropdownWidth = () => {
        const countryList = document.querySelector(".iti__country-list");
        if (countryList && phoneInput) {
            const width = phoneInput.offsetWidth;
            countryList.style.width = `${width}px`;
            countryList.style.maxWidth = '100%';
            countryList.style.overflowX = 'hidden';
        }
    };

    const adjustDropdownHighlightStyle = () => {
        const countryList = document.querySelector(".iti__country-list");
        if (countryList) {
            const selectedCountry = countryList.querySelector(".iti__highlight");
            if (selectedCountry) {
                selectedCountry.style.backgroundColor = "#424A81";
                selectedCountry.style.color = "white";
            }
        }
    };

    const adjustDropdownHoverStyle = () => {
        const countryItems = document.querySelectorAll(".iti__country");
        countryItems.forEach(item => {
            item.addEventListener("mouseenter", function() {
                this.style.backgroundColor = "#424A81";
                this.style.color = "white";
            });
            item.addEventListener("mouseleave", function() {
                this.style.backgroundColor = "";
                this.style.color = "";
            });
        });
    };
    

    // Adjust .iti--fullscreen-popup position for mobile and desktop
    const adjustFullscreenPopup = () => {
        const fullscreenPopup = document.querySelector(".iti--fullscreen-popup");
        if (fullscreenPopup) {
            fullscreenPopup.style.top = (window.innerWidth <= 767) ? '30px' : '0';
        }
    };

    // Adjust dropdown width and fullscreen popup on load, resize, and orientation change
    const applyAdjustments = () => {
        adjustDropdownWidth();
        adjustFullscreenPopup();
        adjustDropdownHoverStyle();
        adjustDropdownHighlightStyle();
    };

    window.addEventListener('load', applyAdjustments);
    window.addEventListener('resize', applyAdjustments);
    window.addEventListener('orientationchange', applyAdjustments);

    // Ensure adjustment is applied immediately
    applyAdjustments();

    // Adjust when the dropdown is opened
    phoneInput.addEventListener('open:countrydropdown', applyAdjustments);
}

$(document).ready(function() { 
    $('.category-content').on('click', function(e) {
        e.preventDefault();
        var category = $(this).closest('label').find('.category-input').data('category');
        clearSessionStorage();
        $('#category').val(category);

        // Remove 'selected-option' class from all buttons
        $('.category-content').removeClass('selected-option');
        
        // Add 'selected-option' class to the clicked button
        $(this).addClass('selected-option');
        $('#category_form').submit();
    });

    const socialMediaOptions = ['Facebook', 'Instagram', 'TikTok', 'Others'];

    function urlHasSubdirectory(url) {
        try {
            // Prepend "https://" if the URL starts with "www." but lacks a protocol
            if (url.startsWith('www.')) {
                url = 'https://' + url;
            } else if (url.startsWith('facebook.com/')) {
                url = 'https://' + url;
            } else if (url.startsWith('instagram.com/')) {
                url = 'https://' + url;
            } else if (url.startsWith('tiktok.com/')) {
                url = 'https://' + url;
            }
            const pathname = new URL(url).pathname;
            return pathname && pathname !== '/' && pathname.split('/').length > 1;
        } catch (e) {
            return false;
        }
    }

    function validateFacebookUrl(url, errorMessageContainer) {

        let isValidFacebookUrl = url.startsWith("https://www.facebook.com/") || url.startsWith("www.facebook.com/") || url.startsWith("facebook.com/");
        let hasSubdirectory = urlHasSubdirectory(url);

        if (!isValidFacebookUrl) {
            errorMessageContainer.html('Please enter a valid Facebook profile URL starting with "facebook.com", "www.facebook.com" or "https://www.facebook.com".');
            errorMessageContainer.show();
            return false;
        } else if (isValidFacebookUrl && !hasSubdirectory) {
            errorMessageContainer.html('URL must include a subdirectory after "facebook.com".');
            errorMessageContainer.show();
            return false;
        } else {
            errorMessageContainer.hide();
            return true;
        }
    }

    function validateInstagramUrl(url, errorMessageContainer) {
        let isValidInstagramUrl = url.startsWith("https://www.instagram.com/") || url.startsWith("www.instagram.com/") || url.startsWith("instagram.com/");
        let hasSubdirectory = urlHasSubdirectory(url);

        if (!isValidInstagramUrl) {
            errorMessageContainer.html('Please enter a valid Instagram profile URL starting with "instagram.com", "www.instagram.com" or "https://www.instagram.com".');
            errorMessageContainer.show();
            return false;
        } else if (isValidInstagramUrl && !hasSubdirectory) {
            errorMessageContainer.html('URL must include a subdirectory after "instagram.com".');
            errorMessageContainer.show();
            return false;
        } else {
            errorMessageContainer.hide();
            return true;
        }
    }

    function validateTikTokUrl(url, errorMessageContainer) {
        let isValidTikTokUrl = url.startsWith("https://www.tiktok.com/") || url.startsWith("www.tiktok.com/") || url.startsWith("tiktok.com/");
        let hasSubdirectory = urlHasSubdirectory(url);

        if (!isValidTikTokUrl) {
            errorMessageContainer.html('Please enter a valid TikTok profile URL starting with "tiktok.com", "www.tiktok.com" or "https://www.tiktok.com".');
            errorMessageContainer.show();
            return false;
        } else if (isValidTikTokUrl && !hasSubdirectory) {
            errorMessageContainer.html('URL must include a subdirectory after "tiktok.com".');
            errorMessageContainer.show();
            return false;
        } else {
            errorMessageContainer.hide();
            return true;
        }
    }

    function validateOtherUrl(url, errorMessageContainer) {
        const errorMessage = 'Please enter a valid URL such as "example.com", "www.example.com" or "https://example.com".';
    
        const invalidChars = /["<>]/;
        if (invalidChars.test(url)) {
            errorMessageContainer.html(errorMessage);
            errorMessageContainer.show();
            return false;
        }
    
        if (url.startsWith('www.')) {
            url = 'https://' + url;
        }
    
        const urlParts = url.split('://');
        let domain = '';
    
        if (urlParts.length === 2) {
            domain = urlParts[1];
        } else if (urlParts.length === 1) {
            domain = urlParts[0];
        } else {
            errorMessageContainer.html(errorMessage);
            errorMessageContainer.show();
            return false;
        }

        const domainParts = domain.split('/');
        domain = domainParts[0];
    
        if (!domain.includes('.') || domain.startsWith('.') || domain.endsWith('.')) {
            errorMessageContainer.html(errorMessage);
            errorMessageContainer.show();
            return false;
        }
    
        errorMessageContainer.hide();
        return true;
    }    

    // Central validation function
    function validateUrl(selectedOption, url, errorMessageContainer) {
        errorMessageContainer.html('');
        errorMessageContainer.hide();

        if (selectedOption === 'Facebook') {
            return validateFacebookUrl(url, errorMessageContainer);
        } else if (selectedOption === 'Instagram') {
            return validateInstagramUrl(url, errorMessageContainer);
        } else if (selectedOption === 'TikTok') {
            return validateTikTokUrl(url, errorMessageContainer);
        } else if (selectedOption === 'Others') {
            return validateOtherUrl(url, errorMessageContainer);
        }
        return true;
    }

    // Function to attach validation handlers
    function attachValidationHandlers(container) {
        const socialInput = container.find('.social-input');
        const customSelect = container.find('.custom-select');
        const errorMessageContainer = container.closest('.form-group').find('.alert-msg');
        const hiddenInput = container.find('input[type="hidden"]');

        function triggerValidation() {
            const selectedOption = hiddenInput.val();
            const url = socialInput.val();
            validateUrl(selectedOption, url, errorMessageContainer);
        }

        customSelect.on('click', function() {
            const dropdown = $(this).closest('.custom-dropdown');
            dropdown.toggleClass('active');
        });

        container.find('.option').on('click', function() {
            const option = $(this);
            const dropdown = option.closest('.custom-dropdown');
            const selectedText = option.text();
            const selectedValue = option.data('value');

            dropdown.find('.selected').text(selectedText);
            hiddenInput.val(selectedValue);
            dropdown.removeClass('active');

            triggerValidation();
            updateDropdownOptions();
        });

        socialInput.on('input', triggerValidation);
    }

    // Initialize the default dropdown
    function initializeDropdown(dropdown) {
        const select = dropdown.querySelector('.custom-select');
        const options = dropdown.querySelectorAll('.option');
        const selected = dropdown.querySelector('.selected');
        const hiddenInput = dropdown.querySelector('input[type="hidden"]');
    
        options.forEach(option => {
            if (option.getAttribute('data-value') === hiddenInput.value) {
                option.classList.add('selected');
                selected.innerText = option.innerText;
            } else {
                option.classList.remove('selected');
            }
        });
    
        select.addEventListener('click', () => {
            dropdown.classList.toggle('active');
        });
    
        options.forEach(option => {
            option.addEventListener('click', () => {
                selected.innerText = option.innerText;
                hiddenInput.value = option.getAttribute('data-value');
                dropdown.classList.remove('active');
                options.forEach(opt => opt.classList.remove('selected'));
                option.classList.add('selected');
                
                const container = $(dropdown).closest('.social-input-container');
                const socialInput = container.find('.social-input');
                const errorMessageContainer = container.closest('.form-group').find('.alert-msg');
                validateUrl(hiddenInput.val(), socialInput.val(), errorMessageContainer);
                updateDropdownOptions();
            });
        });
    
        document.addEventListener('click', e => {
            if (!dropdown.contains(e.target)) {
                dropdown.classList.remove('active');
            }
        });
    }

    $(document).on('click', '.custom-select', function() {
        const dropdownList = $(this).siblings('.dropdown-list');
        dropdownList.toggle();
    });
    
    $(document).on('click', '.dropdown-list .option', function() {
        const selectedValue = $(this).data('value');
        const customSelect = $(this).closest('.custom-dropdown').find('.custom-select');
        customSelect.find('.selected').text(selectedValue);
        $(this).closest('.custom-dropdown').find('input[type="hidden"]').val(selectedValue);
        $(this).closest('.dropdown-list').hide();
    });
    
    $(document).on('click', function(event) {
        if (!$(event.target).closest('.custom-dropdown').length) {
            $('.dropdown-list').hide();
        }
    });
    

    $('#add_profile, .add-profile-icon').on('click', function() {
        const additionalProfiles = $('#additional-profiles');
        const nextOption = socialMediaOptions.find(option => !$(`input[type="hidden"][value="${option}"]`).length);
    
        const selectedOption = nextOption || 'Others';
    
        const newProfile = $(
            `<div class="form-group row justify-content-center">
                <div class="col-12 col-md-8 d-flex social-input-container align-items-center order-1">
                    <i class="fa fa-trash remove-profile-icon" aria-hidden="true"></i>
                    <input type="text" name="social_media_profile[]" class="form-control contact-custom-input social-input mb-0" placeholder="Company social media profile link">
                    <div class="custom-dropdown">
                        <div class="custom-select">
                            <span class="selected">${selectedOption}</span>
                            <div class="caret"></div>
                        </div>
                        <ul class="dropdown-list">
                            <li class="option" data-value="Facebook">Facebook</li>
                            <li class="option" data-value="Instagram">Instagram</li>
                            <li class="option" data-value="TikTok">TikTok</li>
                            <li class="option" data-value="Others">Others</li>
                        </ul>
                        <input type="hidden" name="social_media_type[]" value="${selectedOption}">
                    </div>
                </div>
                <div class="col-12 col-md-4 order-2">
                    <button type="button" class="remove-profile btn btn-link remove-profile-btn">Remove</button>
                </div>
                <div class="col-12 order-3">
                    <div id="error_message_container" class="text-danger alert-msg" role="alert" style="display:none;"></div>
                </div>
            </div>`
        );
        additionalProfiles.append(newProfile);

        attachValidationHandlers(newProfile.find('.social-input-container'));

        newProfile.find('.remove-profile, .remove-profile-icon').on('click', function() {
            newProfile.remove();
            updateDropdownOptions();
        });
    
        updateDropdownOptions();
    });
    

    // Update dropdown options to avoid duplicates
    function updateDropdownOptions() {
        const selectedOptions = [];

        $('.custom-dropdown input[type="hidden"]').each(function() {
            const selectedValue = $(this).val();
            if (selectedValue) {
                selectedOptions.push(selectedValue);
            }
        });

        $('.custom-dropdown').each(function() {
            const currentSelect = $(this);
            const currentValue = currentSelect.find('input[type="hidden"]').val();
            
            currentSelect.find('.option').each(function() {
                const optionValue = $(this).data('value');
                
                // Show all options first
                $(this).show();
                
                // Hide already selected options, except for the currently selected one
                if (selectedOptions.includes(optionValue) && optionValue !== currentValue) {
                    $(this).hide();
                }
            });
        });
    }

    const defaultContainer = $('#contact_form .social-input-container').first();
    attachValidationHandlers(defaultContainer);

    // Apply the function to the current form and initialize any existing dropdowns
    updateDropdownOptions();

    $('.remove-profile, .remove-profile-icon').on('click', function() {
        $(this).closest('.form-group').remove();
        updateDropdownOptions();
    });

    $('#contact_form input, #contact_form textarea').on('keyup input', function() {
        $(this).removeClass('is-invalid');
        if ($(this).attr('id') == 'phone' ){
            $(this).parent().next().removeClass('d-block');
        }
    });

    const radioButtons = $("input[name='answer']");
    const nextButton = $("#btn_next button");

    // Function to retrieve stored answers from sessionStorage
    function getStoredAnswers() {
        const storedAnswers = sessionStorage.getItem('storedAnswers');
        return storedAnswers ? JSON.parse(storedAnswers) : {};
    }

    // Function to save the current answer to sessionStorage
    function saveAnswer(questionId, answer) {
        const storedAnswers = getStoredAnswers();
        storedAnswers[questionId] = answer;
        sessionStorage.setItem('storedAnswers', JSON.stringify(storedAnswers));
    }

    // Function to restore all selected answers and enable the Next button
    function restoreSelectedOptions() {
        const storedAnswers = getStoredAnswers();
        const currentQuestionId = $("#question_number").val();
        let answerRestored = false;

        radioButtons.each(function() {
            const storedAnswer = storedAnswers[currentQuestionId];
            if ($(this).val() === storedAnswer) {
                $(this).prop('checked', true);
                answerRestored = true;
            }
        });

        if (answerRestored) {
            nextButton.prop('disabled', false);
        } else {
            nextButton.prop('disabled', true);
        }
    }

    // Function to reset current question options when category changes
    function resetCurrentQuestionOptions() {
        radioButtons.prop('checked', false);
        nextButton.prop('disabled', true);
    }

    // Function to clear the session storage completely
    function clearSessionStorage() {
        sessionStorage.clear();
        resetCurrentQuestionOptions(); // Ensure options are reset when storage is cleared
    }

    // Restore options on page load
    restoreSelectedOptions();

    // Handle Next button click event
    nextButton.on('click', function() {
        const selectedOption = $("input[name='answer']:checked").val();
        const currentQuestionId = $("#question_number").val();

        // Save the selected answer to sessionStorage
        saveAnswer(currentQuestionId, selectedOption);
    });

    const backButton = $("#back_button");
    if (backButton.length) {
        backButton.on('click', function() {
            restoreSelectedOptions(); // Restore all options when navigating back
        });
    }

    // Enable the Next button when an option is selected
    radioButtons.on('change', function() {
        if ($(this).is(':checked')) {
            nextButton.prop('disabled', false);
        }
    });

    // Automatically enable the Next button if an option is already selected
    if (radioButtons.is(':checked')) {
        nextButton.prop('disabled', false);
    }

    $('#contact_form').on('submit', function(event) {
        let isFormValid = true;

        $('#contact_form .social-input-container').each(function() {
            const socialInput = $(this).find('.social-input');
            const hiddenInput = $(this).find('input[type="hidden"]');
            const errorMessageContainer = $(this).closest('.form-group').next().find('.alert-msg');
            let url = socialInput.val();
            let selectedOption = hiddenInput.val();

            if (url && url.trim() !== "") {
                if (!validateUrl(selectedOption, url, errorMessageContainer)) {
                    isFormValid = false;
                }
            }
        });

        if (!isFormValid) {
            event.preventDefault();
        } else {
            clearSessionStorage();
        }
    });

    updateDropdownOptions();

    $('.option-checkbox').on('change', function() {
        var $content = $(this).closest('.option-button').find('.option-content');
        if (!$(this).is(':checked')) {
            $content.removeClass('selected-option');
        } else {
            $content.addClass('selected-option');
        }
    });

    // Function to toggle visibility of the input field
    function toggleSpecifyInput($element) {
        var $specifyInput = $element.closest('.other-option-wrapper').find('.specify-input');
        if ($specifyInput.hasClass('invisible')) {
            $specifyInput.removeClass('invisible').addClass('visible');
        } else {
            $specifyInput.removeClass('visible').addClass('invisible');
            $specifyInput.val('');
        }
    }

    const $otherCheckbox = $('#other_option');
    const $specifyInput = $('.specify-input');
    const $form = $('#question_form');
    if ($form.length) { // Check if the form element exists
        const $submitButton = $form.find('button[type="submit"]');
        if ($specifyInput.length) {
            $specifyInput.on('input', validateForm);

            // Initial visibility state based on checkbox state
            if ($otherCheckbox.is(':checked')) {
                $specifyInput.removeClass('invisible').addClass('visible');
            }

            // To handle when single choice option with input
            $(".btn-option-input").click(function(){
                // Uncheck all radio buttons
                $('input[type="radio"]').prop('checked', false);
                $(".option-content").removeClass('selected-option');
                // $("#other_option").prop('checked', true);
                toggleSpecifyInput($(this));
            });

            // To handle when other option is click 
            $(".option-content").click(function(){
                toggleSpecifyInput($(this));

                // Check if the clicked element does not have the btn-option-input class
                if (!$(this).hasClass('btn-option-input')) {
                    // Check if #question_form contains any element with .btn-option-input.selected-option
                    if ($("#question_form .btn-option-input").hasClass('selected-option')) {
                        $("#other_option").prop('checked', false);
                        $(".btn-option-input").removeClass('selected-option');
                        $(".specify-input").removeClass('visible').addClass('invisible');
                        $(".specify-input").val("");
                    }

                    // Check if any other .option-content has the .selected-option class
                    if ($(".option-content.selected-option").length > 0) {
                        // Remove the .selected-option class from any other element
                        $(".option-content.selected-option").removeClass('selected-option');
                    }
                }
            });

            // To handle the case when the page loads with "Other" already selected
            $otherCheckbox.on('change', function() {
                if ($(this).is(':checked')) {
                    $specifyInput.removeClass('invisible').addClass('visible');
                } else {
                    $specifyInput.removeClass('visible').addClass('invisible');
                    $specifyInput.val(''); // Clear the input field when the checkbox is unchecked
                }
                validateForm();
            });

            function validateForm() {
                if ($otherCheckbox.is(':checked') && $specifyInput.val().trim() === '') {
                    $submitButton.prop('disabled', true);
                } else {
                    $submitButton.prop('disabled', false);
                }
            }

            validateForm();
        }
    }

    const optionContainers = $(".col-12");
    const secondOptionContainer = optionContainers.eq(1);

    optionContainers.css('visibility', 'hidden');

    function handleOptionChange() {
        const selectedOption = $("input[name='answer']:checked");

        $(".option-content").removeClass('selected-option');

        if (selectedOption.length > 0) {
            selectedOption.closest('.option-content').addClass('selected-option');
        }    

        secondOptionContainer.css('margin-top', '0px');
        optionContainers.css('visibility', 'visible');

        if (selectedOption.length > 0 && selectedOption.val().startsWith("Yes.")) {
            secondOptionContainer.css('margin-top', '50px');
        }
    }

    $("input[name='answer']").on('change', function() {
        handleOptionChange();
    });

    secondOptionContainer.css('margin-top', '0px');
    optionContainers.css('visibility', 'visible');
    
    handleOptionChange();

    var current_question_number = $("#question_number").val();
    if (current_question_number) {
        var current_url = window.location.href;
        var regex = /question-(\d+)/;
        var match = regex.exec(current_url);
        if (match && match[1] !== current_question_number) {
            var new_url = current_url.replace(/question-\d+/, 'question-' + current_question_number);
            window.location.href = new_url;
        }
    }

    // remove validation
    $('.input-target-audience').on('keyup', function() {
        if ($(this).val().trim() !== '') {
            $('.input-target-audience').removeClass('is-invalid').addClass('mb-3');
        }
    });

    // contact page - mobile number validation
    function updateMobileNumberMarginBottom() {
        if ($(window).width() <= 767) {
            if ($('#phone').hasClass('is-invalid')) {
                $('.iti').css('margin-bottom', '0');
            } else {
                $('.iti').css('margin-bottom', '1rem');
            }
        } else {
            $('.iti').css('margin-bottom', '');
        }
    }
    updateMobileNumberMarginBottom();
    $('#phone').on('change keyup', function () {
        updateMobileNumberMarginBottom();
    });

    /**$('#category_form').submit(function(e) {
        e.preventDefault();
        var form_data = new FormData(this);
        var action_url = $(this).attr('action');
        $.ajax({
            type: 'POST',
            url: action_url,
            headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
            data: form_data,
            processData: false,
            contentType: false,
            success: function(data) {
                // console.log(data);
                window.location.href = data.redirect_route
            },
            error:function(xhr, textStatus, errorThrown){
                if (xhr.status === 419) {
                    // Full page reload to refresh the session and CSRF token
                    window.location.reload();
                } else {
                    var data = xhr.responseJSON;
                    // console.log("Error:", data);
                }
            } 
        });
    });**/
});

/**document.addEventListener("DOMContentLoaded", function() {
    const otherCheckbox = document.getElementById('other_option');
    const specifyInput = document.querySelector('.specify-input');
    const form = document.getElementById('question_form');

    if (form) { // Check if the form element exists
        const submitButton = form.querySelector('button[type="submit"]');

        if (specifyInput) {
            // Hide the input field initially
            specifyInput.style.visibility = 'hidden';

            otherCheckbox.addEventListener('change', function() {
                if (this.checked) {
                    specifyInput.style.visibility = 'visible';
                } else {
                    specifyInput.style.visibility = 'hidden';
                    specifyInput.value = '';
                }
                validateForm();
            });

            specifyInput.addEventListener('input', validateForm);

            // To handle the case when the page loads with "Other" already selected
            if (otherCheckbox.checked) {
                specifyInput.style.visibility = 'visible';
            }

            function validateForm() {
                if (otherCheckbox.checked && specifyInput.value.trim() === '') {
                    submitButton.disabled = true;
                } else {
                    submitButton.disabled = false;
                }
            }

            validateForm();
        }
    }
});**/